import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import roleService from '../services/roleService';

const rolesCollectionName = 'roles';
export const useRole = () => {
  return useQuery({
    queryKey: [rolesCollectionName],
    queryFn: () => roleService.getAll(),
    staleTime: 1000 * 60 * 60 * 24,
    cacheTime: 1000 * 60 * 60 * 24,
  });
};

export const useAddRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: roleService.add,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [rolesCollectionName] });
    },
  });
};

export const useEditRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: roleService.edit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [rolesCollectionName] });
    },
  });
};

export const useDeleteRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: roleService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [rolesCollectionName] });
    },
  });
};

export const useRoleNameById = (roleId) => {
  return useQuery({
    queryKey: [rolesCollectionName, roleId],
    queryFn: () => roleService.getNameById(roleId),
    enabled: !!roleId, // only run when roleId is truthy
    staleTime: 1000 * 60 * 60 * 24,
    cacheTime: 1000 * 60 * 60 * 24,
  });
};

export const useRoleIdByName = (roleName) => {
  return useQuery({
    queryKey: [rolesCollectionName, roleName],
    queryFn: () => roleService.getIdByName(roleName),
    enabled: !!roleName, // only run when roleName is truthy
    staleTime: 1000 * 60 * 60 * 24,
    cacheTime: 1000 * 60 * 60 * 24,
  });
};

